/**
 * Global Touch Fix for iOS
 *
 * This script fixes the iOS double-tap issue by properly handling
 * touch events on all links and buttons across the entire page.
 * It distinguishes between scroll gestures and actual tap intentions.
 */

document.addEventListener('DOMContentLoaded', () => {
	// Only run on frontend, not in admin.
	if (window.location.href.includes('/wp-admin/')) return;

	// Find all links and buttons on the entire page.
	const links = document.querySelectorAll('#main-content a');
	const buttons = document.querySelectorAll('#main-content button');
	// Exclude hamburger menu from touch fix as it has its own click handling
	const allElements = [...links, ...buttons].filter(Boolean);

	allElements.forEach((element) => {
		// Skip if the element already has touch event listeners.
		if (element.hasAttribute('data-touch-fixed')) return;

		// Mark this element as having touch fix applied.
		element.setAttribute('data-touch-fixed', 'true');

		let touchStartTime = 0;
		let touchStartX = 0;
		let touchStartY = 0;
		let hasMoved = false;
		let touchMovedDistance = 0;
		const MOVE_THRESHOLD = 10; // pixels
		const TIME_THRESHOLD = 300; // milliseconds

		// Add touch event listeners to ensure proper event handling.
		element.addEventListener('touchstart', (e) => {
			touchStartTime = Date.now();
			touchStartX = e.touches[0].clientX;
			touchStartY = e.touches[0].clientY;
			hasMoved = false;
			touchMovedDistance = 0;
		}, { passive: true });

		element.addEventListener('touchmove', (e) => {
			if (!touchStartTime) return;

			const currentX = e.touches[0].clientX;
			const currentY = e.touches[0].clientY;
			const deltaX = Math.abs(currentX - touchStartX);
			const deltaY = Math.abs(currentY - touchStartY);
			touchMovedDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

			// If the touch has moved more than the threshold, consider it a scroll gesture
			if (touchMovedDistance > MOVE_THRESHOLD) {
				hasMoved = true;
			}
		}, { passive: true });

		element.addEventListener('touchend', (e) => {
			const touchDuration = Date.now() - touchStartTime;

			// Only trigger click if:
			// 1. The touch was brief (under TIME_THRESHOLD)
			// 2. The touch didn't move much (under MOVE_THRESHOLD)
			// 3. This wasn't a scroll gesture
			if (touchDuration < TIME_THRESHOLD && !hasMoved && touchMovedDistance < MOVE_THRESHOLD) {
				e.preventDefault();
				// Programmatically trigger click on the element.
				element.click();
			}

			// Reset values
			touchStartTime = 0;
			hasMoved = false;
			touchMovedDistance = 0;
		}, { passive: false });
	});
});
